// Stroke-outline warning triangle on the 24px grid, used on the redaction
// callout above the report button.
//
// Deliberately a SIBLING of `WarningIcon`, not a replacement for it. That one is
// a 20-grid `fill="currentColor"` glyph used by the auth screens, the two error
// banners, and NotProvisioned; retrofitting it to strokes would silently change
// weight and optical size on five screens outside this slice. Pick by grid, not
// by name: this one for 24-grid stroke contexts, `WarningIcon` for the existing
// 20-grid filled ones.
//
// Decorative — always paired with the visible callout text, so it is
// aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function AlertTriangleIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      {/* Near-zero-length line: round caps render it as the exclamation dot. */}
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}
